module.exports = __webpack_public_path__ + "img/guideline_2.6ff864f5.jpg";